import { hasActiveModuleGrant } from '@realadvisor/constants';

import {
  MODULES_PROSPECTION_MAP,
  MODULES_PROSPECTION_MAP_V2,
} from '@shared/constants/module';
import { isRATenantId } from '@shared/utils/tenant';

type ProspectionMapUser = {
  tenant_id?: string | null;
  is_admin?: boolean | null;
  module_grants?: ReadonlyArray<{ module_id: string }> | null;
};

// Both prospection maps show RealAdvisor's own appraisal leads, so both are
// for RealAdvisor tenants only. The new one is sold separately
// (`prospection_map_v2`); the server enforces the same module on its data —
// see hasura-crm `prospection_map_v2_users` — so this only decides which page
// a user may open and where the sidebar's single "Prospection map" goes.
export const canUseProspectionMapV2 = (user: ProspectionMapUser): boolean =>
  isRATenantId(user.tenant_id ?? '') &&
  (user.is_admin === true ||
    hasActiveModuleGrant(user.module_grants, MODULES_PROSPECTION_MAP_V2));

export const canUseLegacyProspectionMap = (user: ProspectionMapUser): boolean =>
  isRATenantId(user.tenant_id ?? '') &&
  (user.is_admin === true ||
    hasActiveModuleGrant(user.module_grants, MODULES_PROSPECTION_MAP));

export const PROSPECTION_MAP_V2_PATH = '/prospection';
export const LEGACY_PROSPECTION_MAP_PATH = '/maps';

// Where the sidebar's "Prospection map" leads: the new map for those who have
// it, the legacy one otherwise, nothing without either. Admins follow their
// modules too, so they can demo the legacy map by holding only that module;
// an admin with neither module still gets the new map.
export const prospectionMapPath = (user: ProspectionMapUser): string | null => {
  if (!isRATenantId(user.tenant_id ?? '')) {
    return null;
  }
  if (hasActiveModuleGrant(user.module_grants, MODULES_PROSPECTION_MAP_V2)) {
    return PROSPECTION_MAP_V2_PATH;
  }
  if (hasActiveModuleGrant(user.module_grants, MODULES_PROSPECTION_MAP)) {
    return LEGACY_PROSPECTION_MAP_PATH;
  }
  return user.is_admin === true ? PROSPECTION_MAP_V2_PATH : null;
};
